<template>
  <div class="mt-3" style="font-size: 80%">
    <div class="accordion mb-2" id="accordionAnyadirCliente">
      <div class="shadow">
        <button
          class="btn btn-success btn-sm w-100"
          :disabled="
            disabledCrear ||
            !['ROLE_SUPERADMIN', 'ROLE_FINANCE', 'ROLE_SALES'].includes(
              currentUser.roles[0]
            )
          "
          @click="buttonNuevoCliente()"
          type="button"
          data-toggle="collapse"
          data-target="#collapseCliente"
          aria-expanded="false"
          aria-controls="collapseCliente"
        >
          <i class="fas fa-plus-circle"></i>
          Nuevo Cliente
        </button>

        <div
          id="collapseCliente"
          class="collapse"
          aria-labelledby="headingCliente"
          data-parent="#accordionAnyadirCliente"
        >
          <div class="w-100 card-body shadow rounded bg-light">
            <b-form @submit.prevent="procesarFormulario">
              <div class="container">
                <div class="form-row mb-3">
                  <div class="col-md-6">
                    <label for="nombre" class="form-label">Nombre</label>
                    <b-form-input
                      class="form-control"
                      size="sm"
                      v-model="nombre"
                      id="nombre"
                      :disabled="
                        !['ROLE_SUPERADMIN','ROLE_FINANCE','ROLE_SALES','ROLE_TRAINING']
                          .includes(currentUser.roles[0])
                      "
                    ></b-form-input>
                  </div>

                  <div class="col-3">
                    <label for="cif" class="form-label">CIF</label>
                    <b-form-input
                      class="form-control"
                      size="sm"
                      v-model="cif"
                      id="cif"
                      :disabled="
                        !['ROLE_SUPERADMIN','ROLE_FINANCE','ROLE_SALES','ROLE_TRAINING']
                          .includes(currentUser.roles[0])
                      "
                    ></b-form-input>
                  </div>

                  <div class="col-3">
                    <label for="grupoContableIVA" class="form-label">Grupo Contable IVA</label>
                    <b-form-select
                      id="grupoContableIVA"
                      v-model="grupoContableIVA"
                      :options="[
                        { value: '', text: 'Seleccione una opción' },
                        { value: 'NACIONAL', text: 'NACIONAL' },
                        { value: 'UE', text: 'UE' },
                        { value: 'INTERNACIO', text: 'INTERNACIO' },
                      ]"
                      class="form-control"
                      size="sm"
                      :disabled="
                        !['ROLE_SUPERADMIN','ROLE_FINANCE','ROLE_SALES','ROLE_TRAINING']
                          .includes(currentUser.roles[0])
                      "
                    ></b-form-select>
                  </div>
                </div>

                <div class="form-row mb-3">
                  <div class="col-md-6">
                    <label for="cuentaContableX6" class="form-label">Cuenta Contable X6</label>
                    <b-form-input
                      class="form-control"
                      size="sm"
                      v-model="cuentaContableX6"
                      id="cuentaContableX6"
                      :disabled="
                        !['ROLE_SUPERADMIN','ROLE_FINANCE','ROLE_SALES','ROLE_TRAINING']
                          .includes(currentUser.roles[0])
                      "
                    ></b-form-input>
                  </div>

                  <div class="col-md-6">
                    <label for="cuentaContableX8" class="form-label">Cuenta Contable X8</label>
                    <b-form-input
                      class="form-control"
                      size="sm"
                      v-model="cuentaContableX8"
                      id="cuentaContableX8"
                      :disabled="
                        !['ROLE_SUPERADMIN','ROLE_FINANCE','ROLE_SALES','ROLE_TRAINING']
                          .includes(currentUser.roles[0])
                      "
                    ></b-form-input>
                  </div>
                </div>

                <div class="form-row mb-3">
                  <div class="col-md-6">
                    <label for="categoria" class="form-label">Categoría</label>
                    <b-form-select
                      id="categoria"
                      v-model="categoria"
                      :options="[
                        { value: '', text: 'Seleccione una opción' },
                        { value: 'Bajo Riesgo', text: 'Bajo Riesgo' },
                        { value: 'Alto Riesgo', text: 'Alto Riesgo' },
                        { value: 'No Clasificado', text: 'No Clasificado' },
                      ]"
                      class="form-control"
                      size="sm"
                      :disabled="
                        !['ROLE_SUPERADMIN','ROLE_FINANCE','ROLE_SALES','ROLE_TRAINING']
                          .includes(currentUser.roles[0])
                      "
                    ></b-form-select>
                  </div>

                  <div class="col-md-6">
                    <label for="fechaAlta" class="form-label">Fecha Alta</label>
                    <b-form-datepicker
                      id="fechaAlta"
                      v-model="fechaAlta"
                      class="form-control"
                      size="sm"
                      locale="es"
                      :disabled="
                        !['ROLE_SUPERADMIN','ROLE_FINANCE','ROLE_SALES','ROLE_TRAINING']
                          .includes(currentUser.roles[0])
                      "
                    ></b-form-datepicker>
                  </div>
                </div>

                <div class="form-row mb-3">
                  <div class="col-md-12">
                    <label for="condicionesPago" class="form-label">Condiciones de Pago</label>
                    <b-form-input
                      id="condicionesPago"
                      v-model="condicionesPago"
                      class="form-control"
                      size="sm"
                      :disabled="
                        !['ROLE_SUPERADMIN','ROLE_FINANCE','ROLE_SALES','ROLE_TRAINING']
                          .includes(currentUser.roles[0])
                      "
                    ></b-form-input>
                  </div>
                </div>
              
       <div class="form-row mb-3">
  <div class="col-md-12">
    <label for="observacionCliente" class="form-label">Observaciones</label>
    <b-form-textarea
      id="observacionCliente"
      v-model="observacionCliente"
      rows="3"
      max-rows="8"
      size="sm"
      placeholder="Añade aquí las observaciones…"
      :disabled="!['ROLE_SUPERADMIN','ROLE_FINANCE','ROLE_SALES','ROLE_TRAINING'].includes(currentUser.roles[0])"
    />
  </div>
</div>

</div>

              <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <b-button
                  variant="outline-danger"
                  size="sm"
                  class="sm mb-1"
                  data-toggle="collapse"
                  data-target="#collapseCliente"
                  @click="resetUpdate()"
                  ><i class="far fa-times-circle mr-1"></i>Cancelar</b-button
                >
                <b-button
                  variant="primary"
                  size="sm"
                  type="submit"
                  data-toggle="collapse"
                  data-target="#collapseCliente"
                  class="sm mb-1"
                  ><i class="far fa-check-circle mr-1"></i>{{ txtBtnFormulario }}</b-button
                >
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>

    <div class="overflow-auto">
      <b-input-group class="mt-1">
        <b-form-input
          v-model="filter"
          size="sm"
          placeholder="Buscar..."
          class="ml-1 mr-1"
          type="search"
        ></b-form-input>

        <b-pagination
          class="ml-2 mr-2"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="tablaResultados"
          size="sm"
        ></b-pagination>

        <b-form @submit.prevent="obtenerCliente">
          <b-button variant="primary" type="submit" class="btn btn-primary mb-1 mr-1 btn-sm">
            <i class="fas fa-sync"></i>
          </b-button>
        </b-form>
      </b-input-group>

      <b-table
        :key="items.length"
        responsive
        head-variant="light"
        id="tablaResultados"
        :busy="busy"
        :fields="camposTabla"
        :filter="filter"
        :items="items"
        :per-page="perPage"
        :current-page="currentPage"
        small
        :tbody-tr-class="rowClass"
      >
        <template #cell(accion)="row" align="center">
          <b-button-group align="center" size="sm">
            <b-button
              v-if="isSelectionMode"
              type="button"
              size="sm"
              variant="outline-primary"
              @click.stop="seleccionarCliente(row.item)"
              class="mr-1"
              title="Seleccionar para el formulario"
            >
              <i class="fas fa-check-circle"></i>
            </b-button>
            <b-button
              size="sm"
              type="button"
              variant="outline-success"
              data-toggle="collapse"
              :disabled="
                disabledEditar ||
                !['ROLE_SUPERADMIN','ROLE_FINANCE','ROLE_SALES','ROLE_TRAINING']
                  .includes(currentUser.roles[0])
              "
              data-target="#collapseCliente"
              @click="buttonEditarCliente(row.item)"
              class="mr-1"
            >
              <i class="fas fa-edit"></i>
            </b-button>

            <b-button
              :disabled="
                !['ROLE_SUPERADMIN','ROLE_FINANCE','ROLE_SALES','ROLE_TRAINING']
                  .includes(currentUser.roles[0])
              "
              size="sm"
              type="button"
              variant="outline-danger"
              @click="deleteCliente(row.item)"
              class="mr-1"
            >
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </b-button-group>
        </template>

        <template #row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
            </ul>
          </b-card>
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { api1 } from "@/lib/http";

export default {
  name: "Cliente",
  props: {
    isSelectionMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editando: false,
      disabledCrear: false,
      disabledEditar: false,
      txtBtnFormulario: "Guardar",
      ClienteContacto: null,
      filter: "",

      // Campos Cliente
      id: null,
      nombre: "",
      cif: "",
      cuentaContableX6: "",
      cuentaContableX8: "",
      categoria: "",
      fechaAlta: "",
      condicionesPago: "",
      grupoContableIVA: "",
      observacionCliente:"",

      // Tabla/Listado
      busy: false,
      sortBy: "state",
      sortDesc: false,
      perPage: 20,
      currentPage: 1,
      camposTabla: [
        { key: "nombre", label: "Nombre", sortable: true },
        { key: "cif", label: "CIF", sortable: true },
        { key: "condicionesPago", label: "Condiciones de Pago", sortable: true },
        { key: "categoria", label: "Categoría", sortable: true },
        { key: "accion", label: "", thStyle: { width: "130px" } },
      ],
      msgValue: "",
      items: [],
    };
  },
  methods: {
    rowClass(item, type) {
      if (type !== "row") return "";
      if (!item || !item.categoria) return "";
      const categoria = item.categoria.trim().toLowerCase();
      if (categoria === "bajo riesgo") return "fila-riesgo-bajo";
      if (categoria === "alto riesgo") return "fila-riesgo-alto";
      return "";
    },

    procesarFormulario() {
      if (!this.editando) {
        this.sendCliente();
      } else {
        this.updateCliente();
      }
      this.resetUpdate();
    },

    async sendCliente() {
      try {
        await api1.post(`/api/dekra/v204/cliente`, {
          nombre: this.nombre,
          cif: this.cif,
          cuentaContableX6: this.cuentaContableX6,
          cuentaContableX8: this.cuentaContableX8,
          categoria: this.categoria,
          fechaAlta: this.fechaAlta,
          condicionesPago: this.condicionesPago,
          grupoContableIVA: this.grupoContableIVA,
          observacionCliente: this.observacionCliente,
        });
        this.showMsgBoxConfirm("Cliente guardado correctamente", "success", "Confirmación");
        this.obtenerCliente();
      } catch (error) {
        this.showMsgBoxConfirm(
          (error.response?.data?.message || "Error") +
            " - Debug: " +
            (error.response?.data?.debugMessage || "Sin información"),
          "danger",
          "Error"
        );
        if ([401, 403].includes(error.response?.status)) {
          this.$store.dispatch("auth/logout");
          this.$router.push("/login");
        }
      }
    },

    async updateCliente() {
      try {
        await api1.put(`/api/dekra/v204/cliente`, {
          id: this.id,
          nombre: this.nombre,
          cif: this.cif,
          cuentaContableX6: this.cuentaContableX6,
          cuentaContableX8: this.cuentaContableX8,
          categoria: this.categoria,
          fechaAlta: this.fechaAlta,
          condicionesPago: this.condicionesPago,
          grupoContableIVA: this.grupoContableIVA,
          observacionCliente:this.observacionCliente,
        });
        this.showMsgBoxConfirm("Cliente actualizado correctamente", "success", "Confirmación");
        this.obtenerCliente();
      } catch (error) {
        this.showMsgBoxConfirm(
          (error.response?.data?.message || "Error") +
            " - Debug: " +
            (error.response?.data?.debugMessage || "Sin información"),
          "danger",
          "Error"
        );
        if ([401, 403].includes(error.response?.status)) {
          this.$store.dispatch("auth/logout");
          this.$router.push("/login");
        }
      }
    },

    async obtenerCliente() {
      this.busy = true;
      try {
        const { data } = await api1.get(`/api/dekra/v204/cliente`);
        this.items = data;
      } catch (error) {
        this.showMsgBoxConfirm(
          (error.response?.data?.message || "Error") +
            " - Debug: " +
            (error.response?.data?.debugMessage || ""),
          "danger",
          "Error"
        );
        if ([401, 403].includes(error.response?.status)) {
          this.$store.dispatch("auth/logout");
          this.$router.push("/login");
        }
      } finally {
        this.busy = false;
      }
    },

    resetUpdate() {
      this.id = "";
      this.nombre = "";
      this.cif = "";
      this.cuentaContableX6 = "";
      this.cuentaContableX8 = "";
      this.categoria = "";
      this.fechaAlta = "";
      this.condicionesPago = "";
      this.grupoContableIVA = "";
      this.observacionCliente="";
      this.disabledEditar = false;
      this.disabledCrear = false;
      this.obtenerCliente();
    },

    buttonNuevoCliente() {
      this.disabledEditar = !this.disabledEditar;
      this.txtBtnFormulario = "Guardar";
      this.editando = false;
    },

    buttonEditarCliente(item) {
      this.disabledCrear = !this.disabledCrear;
      this.txtBtnFormulario = "Actualizar";
      this.editando = true;

      this.id = item.id;
      this.nombre = item.nombre;
      this.cif = item.cif;
      this.cuentaContableX6 = item.cuentaContableX6;
      this.cuentaContableX8 = item.cuentaContableX8;
      this.categoria = item.categoria;
      this.fechaAlta = item.fechaAlta;
      this.condicionesPago = item.condicionesPago;
      this.grupoContableIVA = item.grupoContableIVA;
      this.observacionCliente= item.observacionCliente;

      this.items = [];
    },

    async deleteCliente(item) {
      if (!confirm("Seguro que lo quieres borrar?")) return;
      try {
        await api1.delete(`/api/dekra/v204/cliente/${item.id}`);
        this.showMsgBoxConfirm("Cliente borrado", "success", "Confirmación");
      } catch (error) {
        this.showMsgBoxConfirm("El cliente no se ha podido borrar", "danger", "Error en el borrado");
        if ([401, 403].includes(error.response?.status)) {
          this.$store.dispatch("auth/logout");
          this.$router.push("/login");
        }
      } finally {
        this.resetUpdate();
      }
    },

    seleccionarCliente(client) {
      this.$emit('client-selected', client);
    },

    showMsgBoxConfirm(msg, vari = "success", title = "Confirmación") {
      this.$bvModal
        .msgBoxOk(msg, {
          title,
          size: "sm",
          buttonSize: "sm",
          okVariant: vari,
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then((value) => {
          this.obtenerCliente();
          this.msgValue = value;
        });
    },
  },
  computed: {
    rows() {
      return this.items.length;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
    this.obtenerCliente();
  },
  components: {},
};
</script>

<style>
.fila-riesgo-bajo td {
  background-color: #d4edda !important;
  color: #155724 !important;
}
.fila-riesgo-alto td {
  background-color: #f8d7da !important;
  color: #721c24 !important;
}
.celdaAccion {
  width: 50px;
}
</style>
